export const FileManagerSelectors = {
    GetUploadedFils: (state) => ({
        files: state.FileManager.files,
        uuid: state.FileManager.uuid,
    }),
};
